export const useIndexStore = defineStore('index', () => {
  const { bannerCategory, homeCategory1, homeCategory2, homeCategory3, home } = useRuntimeConfig().public
  const bannersCategory = ref()
  const recommended1 = ref()
  const recommended2 = ref()
  const recommended3 = ref()
  const html = ref()
  const init = async ({ url }: { url: string }) => {
    const [bannersCategoryData, recommendedData1, recommendedData2, recommendedData3, htmlData] = await Promise.all([
      useFetch(`/store-api/navigation/${bannerCategory}/${bannerCategory}`, {
        method: 'POST',
        body: {
          filter: [
            {
              type: 'not',
              queries: [
                {
                  field: 'category.customFields.category_isBaseCategory',
                  type: 'equals',
                  value: 'true'
                }
              ]
            }
          ],
          includes: {
            category: ['id', 'name', 'media', 'categoryUrlData', 'customFields.category_categoryFooterMap']
          }
        },
        query: {
          url
        }
      }),
      useFetch('/product-listing', {
        method: 'POST',
        body: {
          id: homeCategory1,
          limit: 16,
          url,
          getShowBaseProducts: true
        },
        query: {
          url
        }
      }),
      useFetch('/product-listing', {
        method: 'POST',
        body: {
          id: homeCategory2,
          limit: 12,
          url,
          getShowBaseProducts: true
        },
        query: {
          url
        }
      }),
      useFetch('/product-listing', {
        method: 'POST',
        body: {
          id: homeCategory3,
          limit: 12,
          url,
          getShowBaseProducts: true
        },
        query: {
          url
        }
      }),
      useFetch(`/store-api/cms/${home}`, {
        method: 'POST',
        query: {
          url
        }
      })
    ])
    bannersCategory.value = bannersCategoryData.data.value
    recommended1.value = recommendedData1.data.value
    recommended2.value = recommendedData2.data.value
    recommended3.value = recommendedData3.data.value
    html.value = htmlData.data.value.sections[0].blocks[0].slots[0].config.content.value
  }

  return { bannersCategory, recommended1, recommended2, recommended3, html, init }
})
